import type { ReactNode } from "react";
import { Box } from "@chakra-ui/react";

const ScrollWrapper = ({ children }: { children: ReactNode }) => (
  <Box overflowX="auto" my={{ base: 8, lg: 14 }}>
    {children}
  </Box>
);

export default ScrollWrapper;
